export default [
  {
    path: "/cashiers/pending",
    name: "cashiers-pending",
    component: () => import("@/views/Cashiers/CashiersDashboard.vue"),
  },
  {
    path: "/cashiers/invoices/pending",
    name: "invoices-pending",
    component: () => import("@/views/Cashiers/PendingInvoices.vue"),
  },
  {
    path: "/cashiers/:cashierId/pending",
    name: "cashier-pending",
    component: () => import("@/views/Cashiers/CashierPending.vue"),
  },
  {
    path: "/cashiers/history",
    name: "cashiers-history",
    component: () => import("@/views/Cashiers/CashiersDashboard.vue"),
  },
  {
    path: "/cashiers/:cashierId/history",
    name: "cashier-history",
    component: () => import("@/views/Cashiers/CashierHistory.vue"),
  },
  {
    path: "/invoices/:invoice/receive-payment",
    name: "invoice-receive-payment",
    component: () => import("@/views/Cashiers/ReceivePayment.vue"),
  },
  {
    path: "/invoices/bulk-mark-as-paid",
    name: "invoices-bulk-mark-as-paid",
    component: () => import("@/views/Cashiers/BulkMarkAsPaid.vue"),
  },
];
